const FormatFloat = (value, digits=2, errorValue='-') => {
    let toNumber = parseFloat(value);
    return (isNaN(toNumber))? errorValue: value.toLocaleString('fr-FR', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
const FormatInt = (value, errorValue='-') => {
    let toNumber = parseInt(value);
    return (isNaN(toNumber))? errorValue : toNumber.toLocaleString('fr-FR');
}
const FormatPercent = (value,digits=2, errorValue='-') => {
    return (isNaN(parseFloat(value)))? errorValue : `${FormatFloat(value,digits)}%`;
}
export {FormatPercent,FormatInt,FormatFloat}
